<div class="flex h-full w-10 flex-col items-center gap-2 rounded-l-lg bg-zinc-600 pt-3 text-white">
  <div class="flex flex-col items-stretch text-center">
    <span>{{ (currentPageIndex() ?? 0) + 1 }}</span>
    <hr />
    <span>{{ totalPageCount() }}</span>
  </div>
  <hr class="border-theme-gray-700 w-2/3" />
  <ct-shared-toolbar-button
    #toggleSearchButton
    iconPath="@shared/search"
    (buttonClick)="searchPopover.toggle()" />
  <ct-shared-document-search-popover
    class="fixed z-100"
    #searchPopover
    floatingElement
    [anchor]="toggleSearchButton.button().nativeElement"
    [placement]="'right-start'"
    [isOpened]="searchPopover.isOpen()"
    [offsetConfig]="{ main: 10 }"
    [foundWordsCount]="foundWordsCount()"
    (searchQueried)="searchQueried.emit($event)"
    (searchClear)="searchClear.emit()" />
  <hr class="border-theme-gray-700 w-2/3" />
  <ct-shared-toolbar-button
    iconPath="@shared/zoom-in"
    (buttonClick)="zoomChange.emit(zoomStep)"
    appTooltip="Vergrößern"
    position="right" />
  <ct-shared-toolbar-button
    iconPath="@shared/zoom-out"
    (buttonClick)="zoomChange.emit(-zoomStep)"
    appTooltip="Verkleinern"
    position="right" />
  <ct-shared-toolbar-button
    iconPath="{{ fitType() === 'WIDTH' ? '@shared/fit-height' : '@shared/fit-width' }}"
    (buttonClick)="toggleFitType.emit()"
    appTooltip="An Fenster anpassen"
    position="right" />
  <hr class="border-theme-gray-700 w-2/3" />
  <ct-shared-toolbar-button iconPath="@shared/rotate-right" (buttonClick)="onRotateClicked()" />
  <hr class="border-theme-gray-700 w-2/3" />
  <ng-content></ng-content>
</div>
